/**
 * Files Tab (Placeholder)
 *
 * Placeholder component for file attachments and documents
 */

import React from 'react';
import { Paperclip, Upload } from 'lucide-react';

export const FilesTab: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          Files & Attachments
        </h3>
        <button className="flex items-center gap-2 px-3 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Upload className="w-4 h-4" />
          Upload File
        </button>
      </div>

      <div className="bg-white dark:bg-[#1e293b] rounded-lg border border-gray-200 dark:border-gray-700 p-12">
        <div className="text-center">
          <Paperclip className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            No files uploaded
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Documents and attachments related to this record will appear here.
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-500">
            Coming soon - Drag and drop support
          </p>
        </div>
      </div>
    </div>
  );
};
